import { Button } from "@classdojo/web/nessie";

type ShufflingAvatarsProps = {
  avatar?: string;
};

export default function ShufflingAvatars({ avatar }: ShufflingAvatarsProps) {
  return (
    <div sx={{ display: "flex", flexDirection: "column", flex: 1, paddingTop: "dt_s", position: "relative" }}>
      <div sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        <img src={avatar} sx={{ maxHeight: 128 }} />
      </div>
      <Button data-name="shuffling_avatars:toolkit.table_topics.shuffling" kind="secondary" disabled>
        Shuffling...
      </Button>
    </div>
  );
}
